<template>
	<div class="content-footer" @click="click">
		<span class="footer-start">40</span>
		<span class="footer-bar"></span>
		<span class="footer-end">42</span>
	</div>
</template>

<script>
export default {
	name: "ContentFooter",
	methods: {
		click() {
			window.scrollTo(0, 0);
		}
	}
};
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.content-footer {
	font-size: 1.3rem;
	text-align: center;
	font-family: $font-national;
	margin-top: 10em;
	cursor: pointer;
}
.footer-bar {
	display: inline-block;
	border-bottom: 1px solid;
	border-bottom-color: inherit;
	width: 10em;
	position: relative;
	top: -0.2em;
	margin-right: 0.15em;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentFooter.vue